import { useState, useEffect } from 'react';

// Global selection state (shared across components)
let globalSelection: Record<string, boolean> = {};
let selectionListeners: Set<(selection: Record<string, boolean>) => void> = new Set();

const notifySelectionChange = (selection: Record<string, boolean>) => {
    globalSelection = selection;
    selectionListeners.forEach(listener => listener(selection));
};

export const useAccountApplicationsSelection = () => {
    const [selection, setSelection] = useState<Record<string, boolean>>(globalSelection);

    // Subscribe to selection changes
    useEffect(() => {
        const listener = (newSelection: Record<string, boolean>) => {
            setSelection(newSelection);
        };
        selectionListeners.add(listener);
        return () => {
            selectionListeners.delete(listener);
        };
    }, []);

    const handleRowSelection = (id: string, checked: boolean) => {
        const newSelection = { ...globalSelection };

        if (checked) {
            newSelection[id] = true;
        } else {
            delete newSelection[id];
        }

        notifySelectionChange(newSelection);
    };

    const handleSelectAllRows = (checked: boolean, items: any[]) => {
        if (checked) {
            const newSelection = items.reduce((acc, item) => ({
                ...acc,
                [item.id]: true
            }), {});
            notifySelectionChange(newSelection);
        } else {
            notifySelectionChange({});
        }
    };

    const handleClearSelection = () => {
        notifySelectionChange({});
    };

    return {
        selection,
        handleRowSelection,
        handleSelectAllRows,
        handleClearSelection,
    };
};
